import React, { PureComponent } from "react";
import Chart from "chart.js";

let thisBarChart;

export default class BarChart extends PureComponent {
  chartRef = React.createRef();

  componentDidMount() {
    this.buildChart();
  }
  componentDidUpdate() {
    this.buildChart();
  }

  buildChart = () => {
    const myChartRef = this.chartRef.current.getContext("2d");

    if (typeof thisBarChart !== "undefined") thisBarChart.destroy();

    thisBarChart = new Chart(myChartRef, {
      type: "bar",
      data: {
        labels: this.props.labels,
        datasets: [
          {
            label: "Mentions",
            borderColor: "#e599f7",
            lineTension: 0,
            backgroundColor: "#e599f7",
            pointBackgroundColor: "#e599f7",
            pointBorderColor: "transparent",
            pointHoverBackgroundColor: "#e599f7",
            borderWidth: 2,
            pointRadius: 3,
            pointHoverRadius: 6,
            pointHighlightFill: "#fff",
            pointHighlightStroke: "#e599f7",
            data: this.props.data,
          },
        ],
      },
      options: {
        tooltips: {
          backgroundColor: "#212529",
          mode: "index",
          intersect: false,
          titleFontFamily: "sans-serif",
          titleFontStyle: "500",
          bodyFontFamily: "sans-serif",
        },
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              display: true,
              ticks: {
                beginAtZero: true,
                maxTicksLimit: 5,
                padding: 8,
              },
              gridLines: {
                drawBorder: false,
                color: "#dee2e6",
                borderDash: [8, 8],
                borderWidth: 1,
                lineWidth: 1,
                zeroLineBorderDash: [8, 8],
                zeroLineColor: "#dee2e6",
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                fontFamily: "proxima nova",
              },
              gridLines: {
                drawBorder: false,
                display: false,
                color: "#dee2e6",
                borderDash: [8, 8],
                borderWidth: 1,
                lineWidth: 1,
              },
            },
          ],
        },
      },
    });
  };

  render() {
    return (
      <div>
        <div className="chart-bg-2">
          <div className="html-embed sentiment-chart w-embed">
            <canvas
              id="mentionReach"
              width="940"
              height="180"
              ref={this.chartRef}
            ></canvas>
          </div>
        </div>
      </div>
    );
  }
}
